export default __webpack_public_path__ + "2fc00b4ae4b21e819db535415c42199d.png";